import { ALTARSimpleDomainClient } from "./ALTARSimpleDomainClient";
import { ActAdvancedListWorkflowCommand, } from "./commands/ActAdvancedListWorkflowCommand";
import { ActMatterInstanceWorkflowCommand, } from "./commands/ActMatterInstanceWorkflowCommand";
import { AddMatterDraftContentQuestionCommand, } from "./commands/AddMatterDraftContentQuestionCommand";
import { AddMatterQuestionsFromQuestionListCommand, } from "./commands/AddMatterQuestionsFromQuestionListCommand";
import { AddMatterTemplateMatterContentQuestionCommand, } from "./commands/AddMatterTemplateMatterContentQuestionCommand";
import { AddQuestionToQuestionList2Command, } from "./commands/AddQuestionToQuestionList2Command";
import { AddSubTopicCommand, } from "./commands/AddSubTopicCommand";
import { AnswerRapiniItemReviewCommand, } from "./commands/AnswerRapiniItemReviewCommand";
import { ApproveRapiniItemReviewCommand, } from "./commands/ApproveRapiniItemReviewCommand";
import { AssignMatterDraftContentQuestionCommand, } from "./commands/AssignMatterDraftContentQuestionCommand";
import { AttachFileRapiniItemReviewTaskCommand, } from "./commands/AttachFileRapiniItemReviewTaskCommand";
import { BatchDeleteAdvancedListItemAttachmentCommand, } from "./commands/BatchDeleteAdvancedListItemAttachmentCommand";
import { BatchGetRapiniQuestionDownloadUrlsCommand, } from "./commands/BatchGetRapiniQuestionDownloadUrlsCommand";
import { BatchUpdatePermissionForMatterQuestionCommand, } from "./commands/BatchUpdatePermissionForMatterQuestionCommand";
import { BatchUploadAdvancedListItemAttachmentCommand, } from "./commands/BatchUploadAdvancedListItemAttachmentCommand";
import { BuildAdvancedListWorkflowContextCommand, } from "./commands/BuildAdvancedListWorkflowContextCommand";
import { BuildMatterInstanceWorkflowContextCommand, } from "./commands/BuildMatterInstanceWorkflowContextCommand";
import { BulkGetMatterDraftContentQuestionCommand, } from "./commands/BulkGetMatterDraftContentQuestionCommand";
import { BulkGetMatterPublishedContentQuestionCommand, } from "./commands/BulkGetMatterPublishedContentQuestionCommand";
import { BulkGetMatterTemplateMatterContentQuestionsCommand, } from "./commands/BulkGetMatterTemplateMatterContentQuestionsCommand";
import { CloseMatterOCEngagementCommand, } from "./commands/CloseMatterOCEngagementCommand";
import { CommentRapiniItemReviewTaskCommand, } from "./commands/CommentRapiniItemReviewTaskCommand";
import { CreateAdvancedListCommand, } from "./commands/CreateAdvancedListCommand";
import { CreateAdvancedListItemCommand, } from "./commands/CreateAdvancedListItemCommand";
import { CreateAdvancedListViewCommand, } from "./commands/CreateAdvancedListViewCommand";
import { CreateAdvancedListWorkflowCommand, } from "./commands/CreateAdvancedListWorkflowCommand";
import { CreateAdvancedListWorkflowExecutionByItemCommand, } from "./commands/CreateAdvancedListWorkflowExecutionByItemCommand";
import { CreateAdvancedListWorkflowExecutionCommand, } from "./commands/CreateAdvancedListWorkflowExecutionCommand";
import { CreateEntityRelationCommand, } from "./commands/CreateEntityRelationCommand";
import { CreateInstanceAllowedTeamCommand, } from "./commands/CreateInstanceAllowedTeamCommand";
import { CreateInstanceAuthzCommand, } from "./commands/CreateInstanceAuthzCommand";
import { CreateInstanceCommand, } from "./commands/CreateInstanceCommand";
import { CreateInstanceRoleCommand, } from "./commands/CreateInstanceRoleCommand";
import { CreateLabelCommand, } from "./commands/CreateLabelCommand";
import { CreateLocationCommand, } from "./commands/CreateLocationCommand";
import { CreateMatterCommand, } from "./commands/CreateMatterCommand";
import { CreateMatterDraftContentClientFacingFolderCommand, } from "./commands/CreateMatterDraftContentClientFacingFolderCommand";
import { CreateMatterDraftContentCommand, } from "./commands/CreateMatterDraftContentCommand";
import { CreateMatterDraftContentLegalOnlyFolderCommand, } from "./commands/CreateMatterDraftContentLegalOnlyFolderCommand";
import { CreateMatterInstanceWorkflowCommand, } from "./commands/CreateMatterInstanceWorkflowCommand";
import { CreateMatterInstanceWorkflowExecutionCommand, } from "./commands/CreateMatterInstanceWorkflowExecutionCommand";
import { CreateMatterInstanceWorkflowExecutionForMatterCommand, } from "./commands/CreateMatterInstanceWorkflowExecutionForMatterCommand";
import { CreateMatterOwnerInactiveWorkflowCommand, } from "./commands/CreateMatterOwnerInactiveWorkflowCommand";
import { CreateMatterRefreshWorkflowCommand, } from "./commands/CreateMatterRefreshWorkflowCommand";
import { CreateMatterTemplateCommand, } from "./commands/CreateMatterTemplateCommand";
import { CreateOCFirmCommand, } from "./commands/CreateOCFirmCommand";
import { CreateOCFirmGroupCommand, } from "./commands/CreateOCFirmGroupCommand";
import { CreateOCUserCommand, } from "./commands/CreateOCUserCommand";
import { CreateQuestionList2Command, } from "./commands/CreateQuestionList2Command";
import { CreateRapiniItemCommand, } from "./commands/CreateRapiniItemCommand";
import { CreateRapiniItemReviewCommand, } from "./commands/CreateRapiniItemReviewCommand";
import { CreateRapiniItemReviewTaskCommand, } from "./commands/CreateRapiniItemReviewTaskCommand";
import { CreateRapiniQuestionTreeCommand, } from "./commands/CreateRapiniQuestionTreeCommand";
import { CreateTasksRapiniItemReviewCommand, } from "./commands/CreateTasksRapiniItemReviewCommand";
import { CreateTemplateFromMatterQuestionsCommand, } from "./commands/CreateTemplateFromMatterQuestionsCommand";
import { CreateTopicCommand, } from "./commands/CreateTopicCommand";
import { DeleteAdvancedListCommand, } from "./commands/DeleteAdvancedListCommand";
import { DeleteAdvancedListItemCommand, } from "./commands/DeleteAdvancedListItemCommand";
import { DeleteAdvancedListViewCommand, } from "./commands/DeleteAdvancedListViewCommand";
import { DeleteAdvancedListWorkflowCommand, } from "./commands/DeleteAdvancedListWorkflowCommand";
import { DeleteEntityRelationCommand, } from "./commands/DeleteEntityRelationCommand";
import { DeleteInstanceAllowedTeamCommand, } from "./commands/DeleteInstanceAllowedTeamCommand";
import { DeleteInstanceAuthzCommand, } from "./commands/DeleteInstanceAuthzCommand";
import { DeleteInstanceRoleCommand, } from "./commands/DeleteInstanceRoleCommand";
import { DeleteMatterCommand, } from "./commands/DeleteMatterCommand";
import { DeleteMatterDraftContentClientFacingFileCommand, } from "./commands/DeleteMatterDraftContentClientFacingFileCommand";
import { DeleteMatterDraftContentClientFacingFolderCommand, } from "./commands/DeleteMatterDraftContentClientFacingFolderCommand";
import { DeleteMatterDraftContentLegalOnlyFileCommand, } from "./commands/DeleteMatterDraftContentLegalOnlyFileCommand";
import { DeleteMatterDraftContentLegalOnlyFolderCommand, } from "./commands/DeleteMatterDraftContentLegalOnlyFolderCommand";
import { DeleteMatterTemplateCommand, } from "./commands/DeleteMatterTemplateCommand";
import { DeleteQuestionsFromQuestionList2Command, } from "./commands/DeleteQuestionsFromQuestionList2Command";
import { DeleteRapiniItemCommand, } from "./commands/DeleteRapiniItemCommand";
import { DeleteUserItemCommand, } from "./commands/DeleteUserItemCommand";
import { DownloadAdvancedListItemAttachmentCommand, } from "./commands/DownloadAdvancedListItemAttachmentCommand";
import { DownloadMatterDraftContentClientFacingFileCommand, } from "./commands/DownloadMatterDraftContentClientFacingFileCommand";
import { DownloadMatterDraftContentLegalOnlyFileCommand, } from "./commands/DownloadMatterDraftContentLegalOnlyFileCommand";
import { DownloadMatterPublishedClientFacingFileCommand, } from "./commands/DownloadMatterPublishedClientFacingFileCommand";
import { DownloadMatterPublishedLegalOnlyFileCommand, } from "./commands/DownloadMatterPublishedLegalOnlyFileCommand";
import { DownloadRapiniAttachmentCommand, } from "./commands/DownloadRapiniAttachmentCommand";
import { EditRapiniItemCommand, } from "./commands/EditRapiniItemCommand";
import { EvaluateAdvancedListWorkflowCommand, } from "./commands/EvaluateAdvancedListWorkflowCommand";
import { EvaluateMatterInstanceWorkflowCommand, } from "./commands/EvaluateMatterInstanceWorkflowCommand";
import { GenInstanceSandboxFileGetUrlCommand, } from "./commands/GenInstanceSandboxFileGetUrlCommand";
import { GenInstanceSandboxFilePutUrlCommand, } from "./commands/GenInstanceSandboxFilePutUrlCommand";
import { GetAllOCUserGroupMembershipCommand, } from "./commands/GetAllOCUserGroupMembershipCommand";
import { GetEntityRelationCommand, } from "./commands/GetEntityRelationCommand";
import { GetInstanceAllowedTeamCommand, } from "./commands/GetInstanceAllowedTeamCommand";
import { GetInstanceAuthzCommand, } from "./commands/GetInstanceAuthzCommand";
import { GetInstanceCommand, } from "./commands/GetInstanceCommand";
import { GetInstanceRoleCommand, } from "./commands/GetInstanceRoleCommand";
import { GetLabelCommand, } from "./commands/GetLabelCommand";
import { GetLocationCommand, } from "./commands/GetLocationCommand";
import { GetMatterChatLastReadMessageVersionCommand, } from "./commands/GetMatterChatLastReadMessageVersionCommand";
import { GetMatterCommand, } from "./commands/GetMatterCommand";
import { GetMatterDraftContentClientFacingFilesCommand, } from "./commands/GetMatterDraftContentClientFacingFilesCommand";
import { GetMatterDraftContentCommand, } from "./commands/GetMatterDraftContentCommand";
import { GetMatterDraftContentLegalOnlyFilesCommand, } from "./commands/GetMatterDraftContentLegalOnlyFilesCommand";
import { GetMatterDraftContentQuestionCommand, } from "./commands/GetMatterDraftContentQuestionCommand";
import { GetMatterDraftContentQuestionLegalNoteCommand, } from "./commands/GetMatterDraftContentQuestionLegalNoteCommand";
import { GetMatterOCEngagementCommand, } from "./commands/GetMatterOCEngagementCommand";
import { GetMatterPublishedClientFacingFilesCommand, } from "./commands/GetMatterPublishedClientFacingFilesCommand";
import { GetMatterPublishedContentHistoryByVersionCommand, } from "./commands/GetMatterPublishedContentHistoryByVersionCommand";
import { GetMatterPublishedContentQuestionByVersionCommand, } from "./commands/GetMatterPublishedContentQuestionByVersionCommand";
import { GetMatterPublishedContentQuestionCommand, } from "./commands/GetMatterPublishedContentQuestionCommand";
import { GetMatterPublishedContentQuestionLegalNoteByVersionCommand, } from "./commands/GetMatterPublishedContentQuestionLegalNoteByVersionCommand";
import { GetMatterPublishedContentQuestionLegalNoteCommand, } from "./commands/GetMatterPublishedContentQuestionLegalNoteCommand";
import { GetMatterPublishedLegalOnlyFilesCommand, } from "./commands/GetMatterPublishedLegalOnlyFilesCommand";
import { GetMatterTemplateCommand, } from "./commands/GetMatterTemplateCommand";
import { GetOCFirmCommand, } from "./commands/GetOCFirmCommand";
import { GetOCFirmGroupCommand, } from "./commands/GetOCFirmGroupCommand";
import { GetOCUserCommand, } from "./commands/GetOCUserCommand";
import { GetPublishedMatterContentCommand, } from "./commands/GetPublishedMatterContentCommand";
import { GetQuestionList2Command, } from "./commands/GetQuestionList2Command";
import { GetQuestionList2QuestionCommand, } from "./commands/GetQuestionList2QuestionCommand";
import { GetRapiniItemCommand, } from "./commands/GetRapiniItemCommand";
import { GetRapiniItemReviewCommand, } from "./commands/GetRapiniItemReviewCommand";
import { GetRapiniItemReviewTaskCommand, } from "./commands/GetRapiniItemReviewTaskCommand";
import { GetRapiniQuestionTreeCommand, } from "./commands/GetRapiniQuestionTreeCommand";
import { GetTopicCommand, } from "./commands/GetTopicCommand";
import { GetUserAllowedTeamsCommand, } from "./commands/GetUserAllowedTeamsCommand";
import { GetUserItemCommand, } from "./commands/GetUserItemCommand";
import { GetUserRolesCommand, } from "./commands/GetUserRolesCommand";
import { GrantPermissionForHighlyConfidentialMatterCommand, } from "./commands/GrantPermissionForHighlyConfidentialMatterCommand";
import { GrantPermissionToTeamForMatterQuestionCommand, } from "./commands/GrantPermissionToTeamForMatterQuestionCommand";
import { IndexAdvancedListItemCommand, } from "./commands/IndexAdvancedListItemCommand";
import { IndexAdvancedListViewCommand, } from "./commands/IndexAdvancedListViewCommand";
import { IndexEntityRelationCommand, } from "./commands/IndexEntityRelationCommand";
import { IndexLabelCommand, } from "./commands/IndexLabelCommand";
import { IndexLocationCommand, } from "./commands/IndexLocationCommand";
import { IndexMatterChatLastReadMessageCommand, } from "./commands/IndexMatterChatLastReadMessageCommand";
import { IndexMatterChatMessageCommand, } from "./commands/IndexMatterChatMessageCommand";
import { IndexMatterDraftContentHistoryCommand, } from "./commands/IndexMatterDraftContentHistoryCommand";
import { IndexMatterForSearchNewCommand, } from "./commands/IndexMatterForSearchNewCommand";
import { IndexMatterForSmartSearchCommand, } from "./commands/IndexMatterForSmartSearchCommand";
import { IndexMatterPublishedContentHistoryCommand, } from "./commands/IndexMatterPublishedContentHistoryCommand";
import { IndexMatterTemplateCommand, } from "./commands/IndexMatterTemplateCommand";
import { IndexOCFirmCommand, } from "./commands/IndexOCFirmCommand";
import { IndexOCUserCommand, } from "./commands/IndexOCUserCommand";
import { IndexQuestionList2Command, } from "./commands/IndexQuestionList2Command";
import { IndexRapiniItemCommand, } from "./commands/IndexRapiniItemCommand";
import { IndexRapiniItemReviewCommand, } from "./commands/IndexRapiniItemReviewCommand";
import { IndexRapiniItemReviewTaskCommand, } from "./commands/IndexRapiniItemReviewTaskCommand";
import { IndexTopicCommand, } from "./commands/IndexTopicCommand";
import { IndexUserItemCommand, } from "./commands/IndexUserItemCommand";
import { IsAuthorizedCommand, } from "./commands/IsAuthorizedCommand";
import { LoadAdvancedListCommand, } from "./commands/LoadAdvancedListCommand";
import { LoadAdvancedListItemCommand, } from "./commands/LoadAdvancedListItemCommand";
import { LoadAdvancedListViewCommand, } from "./commands/LoadAdvancedListViewCommand";
import { LoadAdvancedListWorkflowCommand, } from "./commands/LoadAdvancedListWorkflowCommand";
import { LoadAdvancedListWorkflowExecutionCommand, } from "./commands/LoadAdvancedListWorkflowExecutionCommand";
import { LoadMatterInstanceWorkflowCommand, } from "./commands/LoadMatterInstanceWorkflowCommand";
import { LoadMatterInstanceWorkflowExecutionCommand, } from "./commands/LoadMatterInstanceWorkflowExecutionCommand";
import { PermissionTeamToClientFacingFilesCommand, } from "./commands/PermissionTeamToClientFacingFilesCommand";
import { PublishAdvancedListEventCommand, } from "./commands/PublishAdvancedListEventCommand";
import { PublishMatterDraftContentCommand, } from "./commands/PublishMatterDraftContentCommand";
import { PublishMatterOwnerReassignedDomainEventCommand, } from "./commands/PublishMatterOwnerReassignedDomainEventCommand";
import { PublishRapiniEventCommand, } from "./commands/PublishRapiniEventCommand";
import { PutMatterDraftContentQuestionLegalNoteCommand, } from "./commands/PutMatterDraftContentQuestionLegalNoteCommand";
import { PutUserItemCommand, } from "./commands/PutUserItemCommand";
import { ReassignMatterOCEngagementCommand, } from "./commands/ReassignMatterOCEngagementCommand";
import { ReassignMatterOwnerCommand, } from "./commands/ReassignMatterOwnerCommand";
import { RemoveMatterDraftContentQuestionAssignmentCommand, } from "./commands/RemoveMatterDraftContentQuestionAssignmentCommand";
import { RemoveMatterDraftContentQuestionCommand, } from "./commands/RemoveMatterDraftContentQuestionCommand";
import { ReorderMatterDraftContentQuestionsCommand, } from "./commands/ReorderMatterDraftContentQuestionsCommand";
import { ReviewMatterOCEngagementCommand, } from "./commands/ReviewMatterOCEngagementCommand";
import { RevokePermissionForHighlyConfidentialMatterCommand, } from "./commands/RevokePermissionForHighlyConfidentialMatterCommand";
import { RevokePermissionFromClientFacingFilesCommand, } from "./commands/RevokePermissionFromClientFacingFilesCommand";
import { RevokePermissionFromMatterQuestionCommand, } from "./commands/RevokePermissionFromMatterQuestionCommand";
import { RunAdvancedListWorkflowExecutionCommand, } from "./commands/RunAdvancedListWorkflowExecutionCommand";
import { RunMatterInstanceWorkflowExecutionCommand, } from "./commands/RunMatterInstanceWorkflowExecutionCommand";
import { SearchAdvancedListItemsCommand, } from "./commands/SearchAdvancedListItemsCommand";
import { SearchAdvancedListViewsCommand, } from "./commands/SearchAdvancedListViewsCommand";
import { SearchAdvancedListWorkflowCommand, } from "./commands/SearchAdvancedListWorkflowCommand";
import { SearchAdvancedListWorkflowExecutionCommand, } from "./commands/SearchAdvancedListWorkflowExecutionCommand";
import { SearchEntityRelationCommand, } from "./commands/SearchEntityRelationCommand";
import { SearchInstanceAllowedTeamCommand, } from "./commands/SearchInstanceAllowedTeamCommand";
import { SearchInstanceAuthzCommand, } from "./commands/SearchInstanceAuthzCommand";
import { SearchInstanceCommand, } from "./commands/SearchInstanceCommand";
import { SearchInstanceRoleCommand, } from "./commands/SearchInstanceRoleCommand";
import { SearchLabelCommand, } from "./commands/SearchLabelCommand";
import { SearchLocationCommand, } from "./commands/SearchLocationCommand";
import { SearchMatterChatLastReadMessageCommand, } from "./commands/SearchMatterChatLastReadMessageCommand";
import { SearchMatterChatMessageCommand, } from "./commands/SearchMatterChatMessageCommand";
import { SearchMatterDraftContentHistoryCommand, } from "./commands/SearchMatterDraftContentHistoryCommand";
import { SearchMatterInstanceWorkflowCommand, } from "./commands/SearchMatterInstanceWorkflowCommand";
import { SearchMatterInstanceWorkflowExecutionCommand, } from "./commands/SearchMatterInstanceWorkflowExecutionCommand";
import { SearchMatterNewCommand, } from "./commands/SearchMatterNewCommand";
import { SearchMatterPublishedContentHistoryCommand, } from "./commands/SearchMatterPublishedContentHistoryCommand";
import { SearchMatterTemplateCommand, } from "./commands/SearchMatterTemplateCommand";
import { SearchOCFirmCommand, } from "./commands/SearchOCFirmCommand";
import { SearchOCFirmGroupCommand, } from "./commands/SearchOCFirmGroupCommand";
import { SearchOCUserCommand, } from "./commands/SearchOCUserCommand";
import { SearchQuestionList2Command, } from "./commands/SearchQuestionList2Command";
import { SearchRapiniItemCommand, } from "./commands/SearchRapiniItemCommand";
import { SearchRapiniItemReviewCommand, } from "./commands/SearchRapiniItemReviewCommand";
import { SearchRapiniItemReviewTaskCommand, } from "./commands/SearchRapiniItemReviewTaskCommand";
import { SearchTopicCommand, } from "./commands/SearchTopicCommand";
import { SearchUserItemCommand, } from "./commands/SearchUserItemCommand";
import { SendMatterChatMessageCommand, } from "./commands/SendMatterChatMessageCommand";
import { SetMatterHighlyConfidentialCommand, } from "./commands/SetMatterHighlyConfidentialCommand";
import { SmartSearchMatterCommand, } from "./commands/SmartSearchMatterCommand";
import { SmartSearchResultFeedbackCommand, } from "./commands/SmartSearchResultFeedbackCommand";
import { SoftDeleteOCFirmCommand, } from "./commands/SoftDeleteOCFirmCommand";
import { SoftDeleteOCFirmGroupCommand, } from "./commands/SoftDeleteOCFirmGroupCommand";
import { SoftDeleteOCUserCommand, } from "./commands/SoftDeleteOCUserCommand";
import { StartMatterOCEngagementCommand, } from "./commands/StartMatterOCEngagementCommand";
import { SubmitMatterOCEngagementCommand, } from "./commands/SubmitMatterOCEngagementCommand";
import { SubmitRapiniItemReviewCommand, } from "./commands/SubmitRapiniItemReviewCommand";
import { TrackUserActivityCommand, } from "./commands/TrackUserActivityCommand";
import { UnIndexMatterForSearchNewCommand, } from "./commands/UnIndexMatterForSearchNewCommand";
import { UnIndexMatterForSmartSearchCommand, } from "./commands/UnIndexMatterForSmartSearchCommand";
import { UnIndexOCFirmCommand, } from "./commands/UnIndexOCFirmCommand";
import { UnIndexOCUserCommand, } from "./commands/UnIndexOCUserCommand";
import { UnindexAdvancedListItemCommand, } from "./commands/UnindexAdvancedListItemCommand";
import { UnindexAdvancedListViewCommand, } from "./commands/UnindexAdvancedListViewCommand";
import { UnindexMatterTemplateCommand, } from "./commands/UnindexMatterTemplateCommand";
import { UnindexRapiniItemCommand, } from "./commands/UnindexRapiniItemCommand";
import { UnindexUserItemCommand, } from "./commands/UnindexUserItemCommand";
import { UnsetMatterHighlyConfidentialCommand, } from "./commands/UnsetMatterHighlyConfidentialCommand";
import { UpdateAdvancedListCommand, } from "./commands/UpdateAdvancedListCommand";
import { UpdateAdvancedListItemCommand, } from "./commands/UpdateAdvancedListItemCommand";
import { UpdateAdvancedListViewCommand, } from "./commands/UpdateAdvancedListViewCommand";
import { UpdateAdvancedListWorkflowCommand, } from "./commands/UpdateAdvancedListWorkflowCommand";
import { UpdateInstanceAllowedTeamCommand, } from "./commands/UpdateInstanceAllowedTeamCommand";
import { UpdateInstanceCommand, } from "./commands/UpdateInstanceCommand";
import { UpdateInstanceRoleCommand, } from "./commands/UpdateInstanceRoleCommand";
import { UpdateLabelCommand, } from "./commands/UpdateLabelCommand";
import { UpdateLocationCommand, } from "./commands/UpdateLocationCommand";
import { UpdateMatterBackgroundCommand, } from "./commands/UpdateMatterBackgroundCommand";
import { UpdateMatterChatLastReadMessageVersionCommand, } from "./commands/UpdateMatterChatLastReadMessageVersionCommand";
import { UpdateMatterDraftContentClientFacingFolderCommand, } from "./commands/UpdateMatterDraftContentClientFacingFolderCommand";
import { UpdateMatterDraftContentLegalOnlyFolderCommand, } from "./commands/UpdateMatterDraftContentLegalOnlyFolderCommand";
import { UpdateMatterDraftContentQuestionCommand, } from "./commands/UpdateMatterDraftContentQuestionCommand";
import { UpdateMatterDraftContentQuestionLabelsCommand, } from "./commands/UpdateMatterDraftContentQuestionLabelsCommand";
import { UpdateMatterDraftDetailCommand, } from "./commands/UpdateMatterDraftDetailCommand";
import { UpdateMatterInstanceWorkflowCommand, } from "./commands/UpdateMatterInstanceWorkflowCommand";
import { UpdateMatterTemplateCommand, } from "./commands/UpdateMatterTemplateCommand";
import { UpdateMatterTemplateMatterContentQuestionCommand, } from "./commands/UpdateMatterTemplateMatterContentQuestionCommand";
import { UpdateOCFirmCommand, } from "./commands/UpdateOCFirmCommand";
import { UpdateOCFirmGroupCommand, } from "./commands/UpdateOCFirmGroupCommand";
import { UpdateOCUserCommand, } from "./commands/UpdateOCUserCommand";
import { UpdateQuestionList2Command, } from "./commands/UpdateQuestionList2Command";
import { UpdateQuestionList2QuestionCommand, } from "./commands/UpdateQuestionList2QuestionCommand";
import { UpdateRapiniItemReviewCommand, } from "./commands/UpdateRapiniItemReviewCommand";
import { UpdateRapiniItemReviewTaskCommand, } from "./commands/UpdateRapiniItemReviewTaskCommand";
import { UpdateTopicCommand, } from "./commands/UpdateTopicCommand";
import { UploadMatterDraftContentClientFacingFileCommand, } from "./commands/UploadMatterDraftContentClientFacingFileCommand";
import { UploadMatterDraftContentLegalOnlyFileCommand, } from "./commands/UploadMatterDraftContentLegalOnlyFileCommand";
import { WorkMatterOCEngagementCommand, } from "./commands/WorkMatterOCEngagementCommand";
export class ALTARSimpleDomain extends ALTARSimpleDomainClient {
    actAdvancedListWorkflow(args, optionsOrCb, cb) {
        const command = new ActAdvancedListWorkflowCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    batchDeleteAdvancedListItemAttachment(args, optionsOrCb, cb) {
        const command = new BatchDeleteAdvancedListItemAttachmentCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    batchUploadAdvancedListItemAttachment(args, optionsOrCb, cb) {
        const command = new BatchUploadAdvancedListItemAttachmentCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    buildAdvancedListWorkflowContext(args, optionsOrCb, cb) {
        const command = new BuildAdvancedListWorkflowContextCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createAdvancedList(args, optionsOrCb, cb) {
        const command = new CreateAdvancedListCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createAdvancedListItem(args, optionsOrCb, cb) {
        const command = new CreateAdvancedListItemCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createAdvancedListView(args, optionsOrCb, cb) {
        const command = new CreateAdvancedListViewCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createAdvancedListWorkflow(args, optionsOrCb, cb) {
        const command = new CreateAdvancedListWorkflowCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createAdvancedListWorkflowExecution(args, optionsOrCb, cb) {
        const command = new CreateAdvancedListWorkflowExecutionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createAdvancedListWorkflowExecutionByItem(args, optionsOrCb, cb) {
        const command = new CreateAdvancedListWorkflowExecutionByItemCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    deleteAdvancedList(args, optionsOrCb, cb) {
        const command = new DeleteAdvancedListCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    deleteAdvancedListItem(args, optionsOrCb, cb) {
        const command = new DeleteAdvancedListItemCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    deleteAdvancedListView(args, optionsOrCb, cb) {
        const command = new DeleteAdvancedListViewCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    deleteAdvancedListWorkflow(args, optionsOrCb, cb) {
        const command = new DeleteAdvancedListWorkflowCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    downloadAdvancedListItemAttachment(args, optionsOrCb, cb) {
        const command = new DownloadAdvancedListItemAttachmentCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    evaluateAdvancedListWorkflow(args, optionsOrCb, cb) {
        const command = new EvaluateAdvancedListWorkflowCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    indexAdvancedListItem(args, optionsOrCb, cb) {
        const command = new IndexAdvancedListItemCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    indexAdvancedListView(args, optionsOrCb, cb) {
        const command = new IndexAdvancedListViewCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    loadAdvancedList(args, optionsOrCb, cb) {
        const command = new LoadAdvancedListCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    loadAdvancedListItem(args, optionsOrCb, cb) {
        const command = new LoadAdvancedListItemCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    loadAdvancedListView(args, optionsOrCb, cb) {
        const command = new LoadAdvancedListViewCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    loadAdvancedListWorkflow(args, optionsOrCb, cb) {
        const command = new LoadAdvancedListWorkflowCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    loadAdvancedListWorkflowExecution(args, optionsOrCb, cb) {
        const command = new LoadAdvancedListWorkflowExecutionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    publishAdvancedListEvent(args, optionsOrCb, cb) {
        const command = new PublishAdvancedListEventCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    runAdvancedListWorkflowExecution(args, optionsOrCb, cb) {
        const command = new RunAdvancedListWorkflowExecutionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    searchAdvancedListItems(args, optionsOrCb, cb) {
        const command = new SearchAdvancedListItemsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    searchAdvancedListViews(args, optionsOrCb, cb) {
        const command = new SearchAdvancedListViewsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    searchAdvancedListWorkflow(args, optionsOrCb, cb) {
        const command = new SearchAdvancedListWorkflowCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    searchAdvancedListWorkflowExecution(args, optionsOrCb, cb) {
        const command = new SearchAdvancedListWorkflowExecutionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    unindexAdvancedListItem(args, optionsOrCb, cb) {
        const command = new UnindexAdvancedListItemCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    unindexAdvancedListView(args, optionsOrCb, cb) {
        const command = new UnindexAdvancedListViewCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    updateAdvancedList(args, optionsOrCb, cb) {
        const command = new UpdateAdvancedListCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    updateAdvancedListItem(args, optionsOrCb, cb) {
        const command = new UpdateAdvancedListItemCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    updateAdvancedListView(args, optionsOrCb, cb) {
        const command = new UpdateAdvancedListViewCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    updateAdvancedListWorkflow(args, optionsOrCb, cb) {
        const command = new UpdateAdvancedListWorkflowCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createEntityRelation(args, optionsOrCb, cb) {
        const command = new CreateEntityRelationCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    deleteEntityRelation(args, optionsOrCb, cb) {
        const command = new DeleteEntityRelationCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getEntityRelation(args, optionsOrCb, cb) {
        const command = new GetEntityRelationCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    indexEntityRelation(args, optionsOrCb, cb) {
        const command = new IndexEntityRelationCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    searchEntityRelation(args, optionsOrCb, cb) {
        const command = new SearchEntityRelationCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createInstance(args, optionsOrCb, cb) {
        const command = new CreateInstanceCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createInstanceAllowedTeam(args, optionsOrCb, cb) {
        const command = new CreateInstanceAllowedTeamCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createInstanceAuthz(args, optionsOrCb, cb) {
        const command = new CreateInstanceAuthzCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createInstanceRole(args, optionsOrCb, cb) {
        const command = new CreateInstanceRoleCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    deleteInstanceAllowedTeam(args, optionsOrCb, cb) {
        const command = new DeleteInstanceAllowedTeamCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    deleteInstanceAuthz(args, optionsOrCb, cb) {
        const command = new DeleteInstanceAuthzCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    deleteInstanceRole(args, optionsOrCb, cb) {
        const command = new DeleteInstanceRoleCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    deleteUserItem(args, optionsOrCb, cb) {
        const command = new DeleteUserItemCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    genInstanceSandboxFileGetUrl(args, optionsOrCb, cb) {
        const command = new GenInstanceSandboxFileGetUrlCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    genInstanceSandboxFilePutUrl(args, optionsOrCb, cb) {
        const command = new GenInstanceSandboxFilePutUrlCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getInstance(args, optionsOrCb, cb) {
        const command = new GetInstanceCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getInstanceAllowedTeam(args, optionsOrCb, cb) {
        const command = new GetInstanceAllowedTeamCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getInstanceAuthz(args, optionsOrCb, cb) {
        const command = new GetInstanceAuthzCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getInstanceRole(args, optionsOrCb, cb) {
        const command = new GetInstanceRoleCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getUserAllowedTeams(args, optionsOrCb, cb) {
        const command = new GetUserAllowedTeamsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getUserItem(args, optionsOrCb, cb) {
        const command = new GetUserItemCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getUserRoles(args, optionsOrCb, cb) {
        const command = new GetUserRolesCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    indexUserItem(args, optionsOrCb, cb) {
        const command = new IndexUserItemCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    isAuthorized(args, optionsOrCb, cb) {
        const command = new IsAuthorizedCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    putUserItem(args, optionsOrCb, cb) {
        const command = new PutUserItemCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    searchInstance(args, optionsOrCb, cb) {
        const command = new SearchInstanceCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    searchInstanceAllowedTeam(args, optionsOrCb, cb) {
        const command = new SearchInstanceAllowedTeamCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    searchInstanceAuthz(args, optionsOrCb, cb) {
        const command = new SearchInstanceAuthzCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    searchInstanceRole(args, optionsOrCb, cb) {
        const command = new SearchInstanceRoleCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    searchUserItem(args, optionsOrCb, cb) {
        const command = new SearchUserItemCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    smartSearchResultFeedback(args, optionsOrCb, cb) {
        const command = new SmartSearchResultFeedbackCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    unindexUserItem(args, optionsOrCb, cb) {
        const command = new UnindexUserItemCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    updateInstance(args, optionsOrCb, cb) {
        const command = new UpdateInstanceCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    updateInstanceAllowedTeam(args, optionsOrCb, cb) {
        const command = new UpdateInstanceAllowedTeamCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    updateInstanceRole(args, optionsOrCb, cb) {
        const command = new UpdateInstanceRoleCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createLabel(args, optionsOrCb, cb) {
        const command = new CreateLabelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getLabel(args, optionsOrCb, cb) {
        const command = new GetLabelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    indexLabel(args, optionsOrCb, cb) {
        const command = new IndexLabelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    searchLabel(args, optionsOrCb, cb) {
        const command = new SearchLabelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    updateLabel(args, optionsOrCb, cb) {
        const command = new UpdateLabelCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createLocation(args, optionsOrCb, cb) {
        const command = new CreateLocationCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getLocation(args, optionsOrCb, cb) {
        const command = new GetLocationCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    indexLocation(args, optionsOrCb, cb) {
        const command = new IndexLocationCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    searchLocation(args, optionsOrCb, cb) {
        const command = new SearchLocationCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    updateLocation(args, optionsOrCb, cb) {
        const command = new UpdateLocationCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    actMatterInstanceWorkflow(args, optionsOrCb, cb) {
        const command = new ActMatterInstanceWorkflowCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    addMatterDraftContentQuestion(args, optionsOrCb, cb) {
        const command = new AddMatterDraftContentQuestionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    addMatterQuestionsFromQuestionList(args, optionsOrCb, cb) {
        const command = new AddMatterQuestionsFromQuestionListCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    assignMatterDraftContentQuestion(args, optionsOrCb, cb) {
        const command = new AssignMatterDraftContentQuestionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    batchUpdatePermissionForMatterQuestion(args, optionsOrCb, cb) {
        const command = new BatchUpdatePermissionForMatterQuestionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    buildMatterInstanceWorkflowContext(args, optionsOrCb, cb) {
        const command = new BuildMatterInstanceWorkflowContextCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    bulkGetMatterDraftContentQuestion(args, optionsOrCb, cb) {
        const command = new BulkGetMatterDraftContentQuestionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    bulkGetMatterPublishedContentQuestion(args, optionsOrCb, cb) {
        const command = new BulkGetMatterPublishedContentQuestionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    closeMatterOCEngagement(args, optionsOrCb, cb) {
        const command = new CloseMatterOCEngagementCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createMatter(args, optionsOrCb, cb) {
        const command = new CreateMatterCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createMatterDraftContent(args, optionsOrCb, cb) {
        const command = new CreateMatterDraftContentCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createMatterDraftContentClientFacingFolder(args, optionsOrCb, cb) {
        const command = new CreateMatterDraftContentClientFacingFolderCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createMatterDraftContentLegalOnlyFolder(args, optionsOrCb, cb) {
        const command = new CreateMatterDraftContentLegalOnlyFolderCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createMatterInstanceWorkflow(args, optionsOrCb, cb) {
        const command = new CreateMatterInstanceWorkflowCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createMatterInstanceWorkflowExecution(args, optionsOrCb, cb) {
        const command = new CreateMatterInstanceWorkflowExecutionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createMatterInstanceWorkflowExecutionForMatter(args, optionsOrCb, cb) {
        const command = new CreateMatterInstanceWorkflowExecutionForMatterCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createMatterOwnerInactiveWorkflow(args, optionsOrCb, cb) {
        const command = new CreateMatterOwnerInactiveWorkflowCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createMatterRefreshWorkflow(args, optionsOrCb, cb) {
        const command = new CreateMatterRefreshWorkflowCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createTemplateFromMatterQuestions(args, optionsOrCb, cb) {
        const command = new CreateTemplateFromMatterQuestionsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    deleteMatter(args, optionsOrCb, cb) {
        const command = new DeleteMatterCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    deleteMatterDraftContentClientFacingFile(args, optionsOrCb, cb) {
        const command = new DeleteMatterDraftContentClientFacingFileCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    deleteMatterDraftContentClientFacingFolder(args, optionsOrCb, cb) {
        const command = new DeleteMatterDraftContentClientFacingFolderCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    deleteMatterDraftContentLegalOnlyFile(args, optionsOrCb, cb) {
        const command = new DeleteMatterDraftContentLegalOnlyFileCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    deleteMatterDraftContentLegalOnlyFolder(args, optionsOrCb, cb) {
        const command = new DeleteMatterDraftContentLegalOnlyFolderCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    downloadMatterDraftContentClientFacingFile(args, optionsOrCb, cb) {
        const command = new DownloadMatterDraftContentClientFacingFileCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    downloadMatterDraftContentLegalOnlyFile(args, optionsOrCb, cb) {
        const command = new DownloadMatterDraftContentLegalOnlyFileCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    downloadMatterPublishedClientFacingFile(args, optionsOrCb, cb) {
        const command = new DownloadMatterPublishedClientFacingFileCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    downloadMatterPublishedLegalOnlyFile(args, optionsOrCb, cb) {
        const command = new DownloadMatterPublishedLegalOnlyFileCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    evaluateMatterInstanceWorkflow(args, optionsOrCb, cb) {
        const command = new EvaluateMatterInstanceWorkflowCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getMatter(args, optionsOrCb, cb) {
        const command = new GetMatterCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getMatterChatLastReadMessageVersion(args, optionsOrCb, cb) {
        const command = new GetMatterChatLastReadMessageVersionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getMatterDraftContent(args, optionsOrCb, cb) {
        const command = new GetMatterDraftContentCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getMatterDraftContentClientFacingFiles(args, optionsOrCb, cb) {
        const command = new GetMatterDraftContentClientFacingFilesCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getMatterDraftContentLegalOnlyFiles(args, optionsOrCb, cb) {
        const command = new GetMatterDraftContentLegalOnlyFilesCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getMatterDraftContentQuestion(args, optionsOrCb, cb) {
        const command = new GetMatterDraftContentQuestionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getMatterDraftContentQuestionLegalNote(args, optionsOrCb, cb) {
        const command = new GetMatterDraftContentQuestionLegalNoteCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getMatterOCEngagement(args, optionsOrCb, cb) {
        const command = new GetMatterOCEngagementCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getMatterPublishedClientFacingFiles(args, optionsOrCb, cb) {
        const command = new GetMatterPublishedClientFacingFilesCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getMatterPublishedContentHistoryByVersion(args, optionsOrCb, cb) {
        const command = new GetMatterPublishedContentHistoryByVersionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getMatterPublishedContentQuestion(args, optionsOrCb, cb) {
        const command = new GetMatterPublishedContentQuestionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getMatterPublishedContentQuestionByVersion(args, optionsOrCb, cb) {
        const command = new GetMatterPublishedContentQuestionByVersionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getMatterPublishedContentQuestionLegalNote(args, optionsOrCb, cb) {
        const command = new GetMatterPublishedContentQuestionLegalNoteCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getMatterPublishedContentQuestionLegalNoteByVersion(args, optionsOrCb, cb) {
        const command = new GetMatterPublishedContentQuestionLegalNoteByVersionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getMatterPublishedLegalOnlyFiles(args, optionsOrCb, cb) {
        const command = new GetMatterPublishedLegalOnlyFilesCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getPublishedMatterContent(args, optionsOrCb, cb) {
        const command = new GetPublishedMatterContentCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    grantPermissionForHighlyConfidentialMatter(args, optionsOrCb, cb) {
        const command = new GrantPermissionForHighlyConfidentialMatterCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    grantPermissionToTeamForMatterQuestion(args, optionsOrCb, cb) {
        const command = new GrantPermissionToTeamForMatterQuestionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    indexMatterChatLastReadMessage(args, optionsOrCb, cb) {
        const command = new IndexMatterChatLastReadMessageCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    indexMatterChatMessage(args, optionsOrCb, cb) {
        const command = new IndexMatterChatMessageCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    indexMatterDraftContentHistory(args, optionsOrCb, cb) {
        const command = new IndexMatterDraftContentHistoryCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    indexMatterForSearchNew(args, optionsOrCb, cb) {
        const command = new IndexMatterForSearchNewCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    indexMatterForSmartSearch(args, optionsOrCb, cb) {
        const command = new IndexMatterForSmartSearchCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    indexMatterPublishedContentHistory(args, optionsOrCb, cb) {
        const command = new IndexMatterPublishedContentHistoryCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    loadMatterInstanceWorkflow(args, optionsOrCb, cb) {
        const command = new LoadMatterInstanceWorkflowCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    loadMatterInstanceWorkflowExecution(args, optionsOrCb, cb) {
        const command = new LoadMatterInstanceWorkflowExecutionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    permissionTeamToClientFacingFiles(args, optionsOrCb, cb) {
        const command = new PermissionTeamToClientFacingFilesCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    publishMatterDraftContent(args, optionsOrCb, cb) {
        const command = new PublishMatterDraftContentCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    publishMatterOwnerReassignedDomainEvent(args, optionsOrCb, cb) {
        const command = new PublishMatterOwnerReassignedDomainEventCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    putMatterDraftContentQuestionLegalNote(args, optionsOrCb, cb) {
        const command = new PutMatterDraftContentQuestionLegalNoteCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    reassignMatterOCEngagement(args, optionsOrCb, cb) {
        const command = new ReassignMatterOCEngagementCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    reassignMatterOwner(args, optionsOrCb, cb) {
        const command = new ReassignMatterOwnerCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    removeMatterDraftContentQuestion(args, optionsOrCb, cb) {
        const command = new RemoveMatterDraftContentQuestionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    removeMatterDraftContentQuestionAssignment(args, optionsOrCb, cb) {
        const command = new RemoveMatterDraftContentQuestionAssignmentCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    reorderMatterDraftContentQuestions(args, optionsOrCb, cb) {
        const command = new ReorderMatterDraftContentQuestionsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    reviewMatterOCEngagement(args, optionsOrCb, cb) {
        const command = new ReviewMatterOCEngagementCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    revokePermissionForHighlyConfidentialMatter(args, optionsOrCb, cb) {
        const command = new RevokePermissionForHighlyConfidentialMatterCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    revokePermissionFromClientFacingFiles(args, optionsOrCb, cb) {
        const command = new RevokePermissionFromClientFacingFilesCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    revokePermissionFromMatterQuestion(args, optionsOrCb, cb) {
        const command = new RevokePermissionFromMatterQuestionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    runMatterInstanceWorkflowExecution(args, optionsOrCb, cb) {
        const command = new RunMatterInstanceWorkflowExecutionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    searchMatterChatLastReadMessage(args, optionsOrCb, cb) {
        const command = new SearchMatterChatLastReadMessageCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    searchMatterChatMessage(args, optionsOrCb, cb) {
        const command = new SearchMatterChatMessageCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    searchMatterDraftContentHistory(args, optionsOrCb, cb) {
        const command = new SearchMatterDraftContentHistoryCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    searchMatterInstanceWorkflow(args, optionsOrCb, cb) {
        const command = new SearchMatterInstanceWorkflowCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    searchMatterInstanceWorkflowExecution(args, optionsOrCb, cb) {
        const command = new SearchMatterInstanceWorkflowExecutionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    searchMatterNew(args, optionsOrCb, cb) {
        const command = new SearchMatterNewCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    searchMatterPublishedContentHistory(args, optionsOrCb, cb) {
        const command = new SearchMatterPublishedContentHistoryCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    sendMatterChatMessage(args, optionsOrCb, cb) {
        const command = new SendMatterChatMessageCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    setMatterHighlyConfidential(args, optionsOrCb, cb) {
        const command = new SetMatterHighlyConfidentialCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    smartSearchMatter(args, optionsOrCb, cb) {
        const command = new SmartSearchMatterCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    startMatterOCEngagement(args, optionsOrCb, cb) {
        const command = new StartMatterOCEngagementCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    submitMatterOCEngagement(args, optionsOrCb, cb) {
        const command = new SubmitMatterOCEngagementCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    unIndexMatterForSearchNew(args, optionsOrCb, cb) {
        const command = new UnIndexMatterForSearchNewCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    unIndexMatterForSmartSearch(args, optionsOrCb, cb) {
        const command = new UnIndexMatterForSmartSearchCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    unsetMatterHighlyConfidential(args, optionsOrCb, cb) {
        const command = new UnsetMatterHighlyConfidentialCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    updateMatterBackground(args, optionsOrCb, cb) {
        const command = new UpdateMatterBackgroundCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    updateMatterChatLastReadMessageVersion(args, optionsOrCb, cb) {
        const command = new UpdateMatterChatLastReadMessageVersionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    updateMatterDraftContentClientFacingFolder(args, optionsOrCb, cb) {
        const command = new UpdateMatterDraftContentClientFacingFolderCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    updateMatterDraftContentLegalOnlyFolder(args, optionsOrCb, cb) {
        const command = new UpdateMatterDraftContentLegalOnlyFolderCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    updateMatterDraftContentQuestion(args, optionsOrCb, cb) {
        const command = new UpdateMatterDraftContentQuestionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    updateMatterDraftContentQuestionLabels(args, optionsOrCb, cb) {
        const command = new UpdateMatterDraftContentQuestionLabelsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    updateMatterDraftDetail(args, optionsOrCb, cb) {
        const command = new UpdateMatterDraftDetailCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    updateMatterInstanceWorkflow(args, optionsOrCb, cb) {
        const command = new UpdateMatterInstanceWorkflowCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    uploadMatterDraftContentClientFacingFile(args, optionsOrCb, cb) {
        const command = new UploadMatterDraftContentClientFacingFileCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    uploadMatterDraftContentLegalOnlyFile(args, optionsOrCb, cb) {
        const command = new UploadMatterDraftContentLegalOnlyFileCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    workMatterOCEngagement(args, optionsOrCb, cb) {
        const command = new WorkMatterOCEngagementCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    addMatterTemplateMatterContentQuestion(args, optionsOrCb, cb) {
        const command = new AddMatterTemplateMatterContentQuestionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    bulkGetMatterTemplateMatterContentQuestions(args, optionsOrCb, cb) {
        const command = new BulkGetMatterTemplateMatterContentQuestionsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createMatterTemplate(args, optionsOrCb, cb) {
        const command = new CreateMatterTemplateCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    deleteMatterTemplate(args, optionsOrCb, cb) {
        const command = new DeleteMatterTemplateCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getMatterTemplate(args, optionsOrCb, cb) {
        const command = new GetMatterTemplateCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    indexMatterTemplate(args, optionsOrCb, cb) {
        const command = new IndexMatterTemplateCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    searchMatterTemplate(args, optionsOrCb, cb) {
        const command = new SearchMatterTemplateCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    unindexMatterTemplate(args, optionsOrCb, cb) {
        const command = new UnindexMatterTemplateCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    updateMatterTemplate(args, optionsOrCb, cb) {
        const command = new UpdateMatterTemplateCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    updateMatterTemplateMatterContentQuestion(args, optionsOrCb, cb) {
        const command = new UpdateMatterTemplateMatterContentQuestionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createOCFirm(args, optionsOrCb, cb) {
        const command = new CreateOCFirmCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createOCFirmGroup(args, optionsOrCb, cb) {
        const command = new CreateOCFirmGroupCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createOCUser(args, optionsOrCb, cb) {
        const command = new CreateOCUserCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getAllOCUserGroupMembership(args, optionsOrCb, cb) {
        const command = new GetAllOCUserGroupMembershipCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getOCFirm(args, optionsOrCb, cb) {
        const command = new GetOCFirmCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getOCFirmGroup(args, optionsOrCb, cb) {
        const command = new GetOCFirmGroupCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getOCUser(args, optionsOrCb, cb) {
        const command = new GetOCUserCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    indexOCFirm(args, optionsOrCb, cb) {
        const command = new IndexOCFirmCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    indexOCUser(args, optionsOrCb, cb) {
        const command = new IndexOCUserCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    searchOCFirm(args, optionsOrCb, cb) {
        const command = new SearchOCFirmCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    searchOCFirmGroup(args, optionsOrCb, cb) {
        const command = new SearchOCFirmGroupCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    searchOCUser(args, optionsOrCb, cb) {
        const command = new SearchOCUserCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    softDeleteOCFirm(args, optionsOrCb, cb) {
        const command = new SoftDeleteOCFirmCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    softDeleteOCFirmGroup(args, optionsOrCb, cb) {
        const command = new SoftDeleteOCFirmGroupCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    softDeleteOCUser(args, optionsOrCb, cb) {
        const command = new SoftDeleteOCUserCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    unIndexOCFirm(args, optionsOrCb, cb) {
        const command = new UnIndexOCFirmCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    unIndexOCUser(args, optionsOrCb, cb) {
        const command = new UnIndexOCUserCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    updateOCFirm(args, optionsOrCb, cb) {
        const command = new UpdateOCFirmCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    updateOCFirmGroup(args, optionsOrCb, cb) {
        const command = new UpdateOCFirmGroupCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    updateOCUser(args, optionsOrCb, cb) {
        const command = new UpdateOCUserCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    addQuestionToQuestionList2(args, optionsOrCb, cb) {
        const command = new AddQuestionToQuestionList2Command(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createQuestionList2(args, optionsOrCb, cb) {
        const command = new CreateQuestionList2Command(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    deleteQuestionsFromQuestionList2(args, optionsOrCb, cb) {
        const command = new DeleteQuestionsFromQuestionList2Command(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getQuestionList2(args, optionsOrCb, cb) {
        const command = new GetQuestionList2Command(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getQuestionList2Question(args, optionsOrCb, cb) {
        const command = new GetQuestionList2QuestionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    indexQuestionList2(args, optionsOrCb, cb) {
        const command = new IndexQuestionList2Command(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    searchQuestionList2(args, optionsOrCb, cb) {
        const command = new SearchQuestionList2Command(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    updateQuestionList2(args, optionsOrCb, cb) {
        const command = new UpdateQuestionList2Command(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    updateQuestionList2Question(args, optionsOrCb, cb) {
        const command = new UpdateQuestionList2QuestionCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    answerRapiniItemReview(args, optionsOrCb, cb) {
        const command = new AnswerRapiniItemReviewCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    approveRapiniItemReview(args, optionsOrCb, cb) {
        const command = new ApproveRapiniItemReviewCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    attachFileRapiniItemReviewTask(args, optionsOrCb, cb) {
        const command = new AttachFileRapiniItemReviewTaskCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    batchGetRapiniQuestionDownloadUrls(args, optionsOrCb, cb) {
        const command = new BatchGetRapiniQuestionDownloadUrlsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    commentRapiniItemReviewTask(args, optionsOrCb, cb) {
        const command = new CommentRapiniItemReviewTaskCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createRapiniItem(args, optionsOrCb, cb) {
        const command = new CreateRapiniItemCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createRapiniItemReview(args, optionsOrCb, cb) {
        const command = new CreateRapiniItemReviewCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createRapiniItemReviewTask(args, optionsOrCb, cb) {
        const command = new CreateRapiniItemReviewTaskCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createRapiniQuestionTree(args, optionsOrCb, cb) {
        const command = new CreateRapiniQuestionTreeCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createTasksRapiniItemReview(args, optionsOrCb, cb) {
        const command = new CreateTasksRapiniItemReviewCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    deleteRapiniItem(args, optionsOrCb, cb) {
        const command = new DeleteRapiniItemCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    downloadRapiniAttachment(args, optionsOrCb, cb) {
        const command = new DownloadRapiniAttachmentCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    editRapiniItem(args, optionsOrCb, cb) {
        const command = new EditRapiniItemCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getRapiniItem(args, optionsOrCb, cb) {
        const command = new GetRapiniItemCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getRapiniItemReview(args, optionsOrCb, cb) {
        const command = new GetRapiniItemReviewCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getRapiniItemReviewTask(args, optionsOrCb, cb) {
        const command = new GetRapiniItemReviewTaskCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getRapiniQuestionTree(args, optionsOrCb, cb) {
        const command = new GetRapiniQuestionTreeCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    indexRapiniItem(args, optionsOrCb, cb) {
        const command = new IndexRapiniItemCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    indexRapiniItemReview(args, optionsOrCb, cb) {
        const command = new IndexRapiniItemReviewCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    indexRapiniItemReviewTask(args, optionsOrCb, cb) {
        const command = new IndexRapiniItemReviewTaskCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    publishRapiniEvent(args, optionsOrCb, cb) {
        const command = new PublishRapiniEventCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    searchRapiniItem(args, optionsOrCb, cb) {
        const command = new SearchRapiniItemCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    searchRapiniItemReview(args, optionsOrCb, cb) {
        const command = new SearchRapiniItemReviewCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    searchRapiniItemReviewTask(args, optionsOrCb, cb) {
        const command = new SearchRapiniItemReviewTaskCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    submitRapiniItemReview(args, optionsOrCb, cb) {
        const command = new SubmitRapiniItemReviewCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    unindexRapiniItem(args, optionsOrCb, cb) {
        const command = new UnindexRapiniItemCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    updateRapiniItemReview(args, optionsOrCb, cb) {
        const command = new UpdateRapiniItemReviewCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    updateRapiniItemReviewTask(args, optionsOrCb, cb) {
        const command = new UpdateRapiniItemReviewTaskCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    addSubTopic(args, optionsOrCb, cb) {
        const command = new AddSubTopicCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createTopic(args, optionsOrCb, cb) {
        const command = new CreateTopicCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getTopic(args, optionsOrCb, cb) {
        const command = new GetTopicCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    indexTopic(args, optionsOrCb, cb) {
        const command = new IndexTopicCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    searchTopic(args, optionsOrCb, cb) {
        const command = new SearchTopicCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    updateTopic(args, optionsOrCb, cb) {
        const command = new UpdateTopicCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    trackUserActivity(args, optionsOrCb, cb) {
        const command = new TrackUserActivityCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
}
